import type { BillingCapability, BillingRecoveryContext } from '@/store/uiStore';

const CAPABILITIES = new Set<BillingCapability>(['TEXT', 'VOICE', 'VIDEO']);

function numberValue(value: unknown): number | undefined {
  return typeof value === 'number' && Number.isFinite(value) ? value : undefined;
}

/** Extracts stable entitlement-denial fields attached to API and SSE errors. */
export function billingRecoveryContext(
  value: unknown,
  fallbackCapability?: BillingCapability
): BillingRecoveryContext {
  const root = typeof value === 'object' && value !== null ? value : {};
  const rootRecord = root as Record<string, unknown>;
  const detail =
    typeof rootRecord['detail'] === 'object' && rootRecord['detail'] !== null
      ? (rootRecord['detail'] as Record<string, unknown>)
      : rootRecord;
  const rawCapability = detail['capability'];
  const capability =
    typeof rawCapability === 'string' && CAPABILITIES.has(rawCapability as BillingCapability)
      ? (rawCapability as BillingCapability)
      : fallbackCapability;
  const requiredCredits = numberValue(detail['required']);
  const balance = numberValue(detail['balance']);

  return {
    ...(capability ? { capability } : {}),
    ...(requiredCredits !== undefined ? { requiredCredits } : {}),
    ...(balance !== undefined ? { balance } : {}),
  };
}
